import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  tableContainer: {
    flex: 1,
    margin: '20px 2% 20px 34px',
  },
  mainTable: {
    width: 'auto',
    height: '616px',
  },

  serviceOrderCell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(4),
    borderRadius: 16,
    backgroundColor: Theme.Colors.Primary.Lightest,
  },
  greenColor: {
    color: Theme.Colors.Green.Base,
  },
  redColor: {
    color: Theme.Colors.Red.Base,
  },
  statusCell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(4, 8),
    borderRadius: 16,
    backgroundColor: Theme.Colors.Grayscale.Four,
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: Theme.Typography.FontSize.XXSmall,
  },
  statusCellDot: {
    marginRight: 8,
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: Theme.Colors.Yellow.Base,
  },
  greenBackground: {
    backgroundColor: Theme.Colors.Green.Base,
  },
  wasntViewed: {
    fontWeight: 500,
  },
  default: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(4),
    borderRadius: spacing(16),
    flex: 1,
  },
  icon: {
    fontSize: spacing(28),
    height: spacing(24),
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
export const datagridStyle = {
  fontSize: Theme.Typography.FontSize.XXSmall,

  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },
}
